import React from 'react';

interface SpeedControlProps {
    speedOptions: number[];
    currentSpeed: number;
    onSpeedChange: (speed: number) => void;
}

const SpeedControl: React.FC<SpeedControlProps> = ({ 
    speedOptions, 
    currentSpeed, 
    onSpeedChange 
}) => {
    return (
        <>
            {/* Speed Control Label */}
            <span style={{ 
                fontSize: '16px', 
                fontWeight: 'bold', 
                color: '#495057',
                marginLeft: '10px' 
            }}>
                Speed:
            </span>

            {/* Speed Buttons */}
            <div style={{ display: 'flex', gap: '4px' }}>
                {speedOptions.map(speed => (
                    <button 
                        onClick={() => onSpeedChange(speed)} 
                        key={speed}
                        style={{
                            padding: '10px 16px',
                            fontSize: '16px',
                            fontWeight: 'normal',
                            backgroundColor: currentSpeed === speed ? '#007bff' : '#ffffff',
                            color: currentSpeed === speed ? '#ffffff' : '#495057',
                            border: currentSpeed === speed ? '2px solid #007bff' : '2px solid #dee2e6',
                            borderRadius: '6px',
                            cursor: 'pointer',
                            transition: 'all 0.2s ease',
                            minWidth: '56px',
                            textAlign: 'center'
                        }}
                        onMouseEnter={(e) => {
                            if (currentSpeed !== speed) {
                                e.currentTarget.style.backgroundColor = '#f8f9fa';
                                e.currentTarget.style.borderColor = '#adb5bd';
                            }
                        }}
                        onMouseLeave={(e) => {
                            if (currentSpeed !== speed) {
                                e.currentTarget.style.backgroundColor = '#ffffff';
                                e.currentTarget.style.borderColor = '#dee2e6';
                            }
                        }}
                    >
                        {speed}x
                    </button>
                ))}
            </div>
        </>
    );
};

export default SpeedControl;